import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IClub, IClubsStore } from './store';

export interface IClubsActions {
  all: () => { clubs: IClubsStore };
  get: (id: number) => { clubs: IClubsStore };
}

const actions: IActionGroup = {
  all: async (state: IStore): Promise<{ clubs: IClubsStore } | { errors: IErrorsStore }> => {
    if (Object.keys(state.clubs.all).length) {
      return { clubs: state.clubs };
    }

    const response = await request.get(`${api.clubs}`);

    if (response.error) {
      return { errors: { clubs: { msg: 'Error retrieving the club list.' } } };
    }

    const allClubs = response.reduce(
      (parsedClubs: IClubsStore, rawClub: IClub) => ({
        ...parsedClubs,
        [rawClub.id]: rawClub
      }),
      {}
    );

    return {
      clubs: {
        all: allClubs
      }
    };
  },
  get: async (
    state: IStore,
    clubId: number
  ): Promise<{ clubs: IClubsStore } | { errors: IErrorsStore }> => {
    if (state.clubs[Number(clubId)]) {
      return { clubs: state.clubs };
    }
    const response = await request.get(`${api.clubs}${clubId}/`);

    if (response.error) {
      return { errors: { clubs: { msg: 'Error retrieving the club.' } } };
    }

    const rawClub: IClub = response;
    return {
      clubs: {
        [rawClub.id]: rawClub
      }
    } as any;
  }
};

export default actions;
